import * as React from 'react';
import { LogbogDialog } from '../../models/LogbogDialog';
import LogbogDialogIndlaeg from './LogbogDialogIndlaeg';

export interface LogbogDialogComponentProps {
    dialog?: LogbogDialog;
    updateIndlaeg: any;
}

export default class LogbogDialogComponent extends React.Component<LogbogDialogComponentProps,
    any> {
    constructor(props: LogbogDialogComponentProps) {
        super(props);
    }

    getIndlaeg = () => {
        if (this.props.dialog !== undefined) {
            return this
                .props
                .dialog
                .logbogIndlaeg
                .map((li, i) => {
                    return <LogbogDialogIndlaeg updateIndlaeg={this.props.updateIndlaeg} key={li.id} logbogIndlaeg={li} />;
                });
        }

        return undefined;
    }

    render() {
        return (
            <div className='logbog-dialog-container'>
                {this.getIndlaeg()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/LogbogDialogComponent.tsx